unit unit_AenderungNewsletter;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Grids, Vcl.Controls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, DB;

type
  TAenderungNewsletter = class(TForm)
    TC: TTableControl;
    xdsKundendaten: TXDataWebDataSet;
    xdsKundendatenKundennummer: TStringField;
    xdsKundendatenEMail: TStringField;
    xdsKundendatenKeinNewsletter: TBooleanField;
    xdsProtokoll: TXDataWebDataSet;
    xdsProtokollID: TIntegerField;
    xdsProtokollDatum: TDateTimeField;
    xdsProtokollKundennummer: TStringField;
    xdsProtokollNotiz: TStringField;
    xdsProtokollPruefungErforderlich: TBooleanField;
    xdsProtokollPruefungErledigt: TDateTimeField;
    xdsProtokollPruefungErledigtDurch: TStringField;
    xdsProtokollBemerkung: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsKundendatenAfterOpen(DataSet: TDataSet);
    procedure xdsKundendatenAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure xdsProtokollAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure xdsProtokollAfterPost(DataSet: TDataSet);
    procedure xdsKundendatenAfterPost(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    btnNewsletterBestellen:TButton;
    btnNewsletterAbmelden:TButton;
    buttonzurueck:TButton;
    procedure btnNewsletterBestellenclick(Sender:TObject);
    procedure btnNewsletterAbmeldenclick(Sender:TObject);
    procedure buttonzurueckclick(Sender:TObject);
    procedure FormularErstellen;
  protected procedure LoadDFMValues; override; end;

var
  AenderungNewsletter: TAenderungNewsletter;

implementation
  uses unit1, unit2;
{$R *.dfm}

procedure TAenderungNewsletter.buttonzurueckclick(Sender:TObject);
begin
  close;
end;

procedure TAenderungNewsletter.btnNewsletterBestellenclick(Sender:TObject);
begin
  xdsKundendaten.Edit;
  xdsKundendatenKeinNewsletter.AsBoolean:=false;
  xdsKundendaten.Post;
end;

procedure TAenderungNewsletter.btnNewsletterAbmeldenclick(Sender:TObject);
begin
  xdsKundendaten.Edit;
  xdsKundendatenKeinNewsletter.AsBoolean:=true;
  xdsKundendaten.Post;
end;

procedure TAenderungNewsletter.FormularErstellen;
var
  myelement:TJSHTMLElement;
  i:integer;
begin
  TC.ColCount:=1;
  TC.RowCount:=6;
  TC.Cells[0,i]:='Einstellung Newsletter';
  inc(i);
  myelement:=TC.cellelements[0,i];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Kundennummer <br><b>'+xdsKundendatenKundennummer.asstring;
  inc(i);
  TC.Cells[0,i]:='<i>Mit unserem Newsletter halten wir Sie stets informiert.';
  inc(i);
  if xdsKundendatenKeinNewsletter.AsBoolean=false then
  begin
    TC.Cells[0,i]:='<b>Sie erhalten unseren Newsletter.';
    inc(i);
    myelement:=TC.cellelements[0,i];
    btnNewsletterAbmelden:=TButton.Create(self);
    btnNewsletterAbmelden.ElementClassName:='btn btn-info text-left';
    btnNewsletterAbmelden.HeightStyle:=ssauto;
    btnNewsletterAbmelden.WidthStyle:=ssauto;
    btnNewsletterAbmelden.tag:=0;
    btnNewsletterAbmelden.Caption:='Ich möchte den Newsletter abbestellen';
    btnNewsletterAbmelden.OnClick:=@btnNewsletterAbmeldenClick;
    btnNewsletterAbmelden.ParentElement:=myelement;
  end
  else
  begin
    TC.Cells[0,i]:='<b>Zur Zeit dürfen wir Sie nicht mittels eines Newsletters informiert halten.';
    inc(i);
    myelement:=TC.cellelements[0,i];
    btnNewsletterBestellen:=TButton.Create(self);
    btnNewsletterBestellen.ElementClassName:='btn btn-info text-left';
    btnNewsletterBestellen.HeightStyle:=ssauto;
    btnNewsletterBestellen.WidthStyle:=ssauto;
    btnNewsletterBestellen.tag:=0;
    btnNewsletterBestellen.Caption:='Ich möchte den Newsletter erhalten';
    btnNewsletterBestellen.OnClick:=@btnNewsletterBestellenClick;
    btnNewsletterBestellen.ParentElement:=myelement;
  end;
end;


procedure TAenderungNewsletter.WebFormShow(Sender: TObject);
begin
  xdsProtokoll.Load;
  xdsKundendaten.Close;
  xdsKundendaten.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer);
  xdsKundendaten.Load;
end;

procedure TAenderungNewsletter.xdsKundendatenAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;

  if info.Records[0].Error='' then
  begin
    xdsProtokoll.Append;
    xdsProtokollDatum.AsDateTime:=date+time;
    xdsProtokollKundennummer.AsString:=xdsKundendatenKundennummer.AsString;
    if xdsKundendatenKeinNewsletter.AsBoolean=false then xdsProtokollNotiz.AsString:='Newsletter bestellt '+InternetIpAdresse;
    if xdsKundendatenKeinNewsletter.AsBoolean=true then xdsProtokollNotiz.AsString:='Newsletter abbestellt '+InternetIpAdresse;
    xdsProtokoll.Post;

  end;
end;

procedure TAenderungNewsletter.xdsKundendatenAfterOpen(DataSet: TDataSet);
begin
  formularerstellen;
end;

procedure TAenderungNewsletter.xdsKundendatenAfterPost(DataSet: TDataSet);
begin
xdsKundendaten.ApplyUpdates;
end;

procedure TAenderungNewsletter.xdsProtokollAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;

  if info.Records[0].Error='' then
  begin
    close;
  end;

end;

procedure TAenderungNewsletter.xdsProtokollAfterPost(DataSet: TDataSet);
begin
  xdsprotokoll.ApplyUpdates;
end;

procedure TAenderungNewsletter.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  xdsKundendaten := TXDataWebDataSet.Create(Self);
  xdsKundendatenKundennummer := TStringField.Create(Self);
  xdsKundendatenEMail := TStringField.Create(Self);
  xdsKundendatenKeinNewsletter := TBooleanField.Create(Self);
  xdsProtokoll := TXDataWebDataSet.Create(Self);
  xdsProtokollID := TIntegerField.Create(Self);
  xdsProtokollDatum := TDateTimeField.Create(Self);
  xdsProtokollKundennummer := TStringField.Create(Self);
  xdsProtokollNotiz := TStringField.Create(Self);
  xdsProtokollPruefungErforderlich := TBooleanField.Create(Self);
  xdsProtokollPruefungErledigt := TDateTimeField.Create(Self);
  xdsProtokollPruefungErledigtDurch := TStringField.Create(Self);
  xdsProtokollBemerkung := TStringField.Create(Self);

  TC.BeforeLoadDFMValues;
  xdsKundendaten.BeforeLoadDFMValues;
  xdsKundendatenKundennummer.BeforeLoadDFMValues;
  xdsKundendatenEMail.BeforeLoadDFMValues;
  xdsKundendatenKeinNewsletter.BeforeLoadDFMValues;
  xdsProtokoll.BeforeLoadDFMValues;
  xdsProtokollID.BeforeLoadDFMValues;
  xdsProtokollDatum.BeforeLoadDFMValues;
  xdsProtokollKundennummer.BeforeLoadDFMValues;
  xdsProtokollNotiz.BeforeLoadDFMValues;
  xdsProtokollPruefungErforderlich.BeforeLoadDFMValues;
  xdsProtokollPruefungErledigt.BeforeLoadDFMValues;
  xdsProtokollPruefungErledigtDurch.BeforeLoadDFMValues;
  xdsProtokollBemerkung.BeforeLoadDFMValues;
  try
    Name := 'AenderungNewsletter';
    Width := 213;
    Height := 307;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 169;
    TC.Height := 289;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    xdsKundendaten.SetParentComponent(Self);
    xdsKundendaten.Name := 'xdsKundendaten';
    xdsKundendaten.AfterApplyUpdates := xdsKundendatenAfterApplyUpdates;
    xdsKundendaten.AfterOpen := xdsKundendatenAfterOpen;
    xdsKundendaten.AfterPost := xdsKundendatenAfterPost;
    xdsKundendaten.EntitySetName := 'Adressen';
    xdsKundendaten.Connection := DM2.XDataWebConnection1;
    xdsKundendaten.Left := 40;
    xdsKundendaten.Top := 104;
    xdsKundendatenKundennummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundennummer.Name := 'xdsKundendatenKundennummer';
    xdsKundendatenKundennummer.FieldName := 'Kundennummer';
    xdsKundendatenKundennummer.Size := 13;
    xdsKundendatenEMail.SetParentComponent(xdsKundendaten);
    xdsKundendatenEMail.Name := 'xdsKundendatenEMail';
    xdsKundendatenEMail.FieldName := 'EMail';
    xdsKundendatenEMail.Size := 50;
    xdsKundendatenKeinNewsletter.SetParentComponent(xdsKundendaten);
    xdsKundendatenKeinNewsletter.Name := 'xdsKundendatenKeinNewsletter';
    xdsKundendatenKeinNewsletter.FieldName := 'KeinNewsletter';
    xdsProtokoll.SetParentComponent(Self);
    xdsProtokoll.Name := 'xdsProtokoll';
    xdsProtokoll.AfterApplyUpdates := xdsProtokollAfterApplyUpdates;
    xdsProtokoll.AfterPost := xdsProtokollAfterPost;
    xdsProtokoll.EntitySetName := 'KundenportalProtokoll';
    xdsProtokoll.Connection := DM2.XDataWebConnection1;
    xdsProtokoll.QueryTop := 1;
    xdsProtokoll.Left := 41;
    xdsProtokoll.Top := 192;
    xdsProtokollID.SetParentComponent(xdsProtokoll);
    xdsProtokollID.Name := 'xdsProtokollID';
    xdsProtokollID.FieldName := 'ID';
    xdsProtokollDatum.SetParentComponent(xdsProtokoll);
    xdsProtokollDatum.Name := 'xdsProtokollDatum';
    xdsProtokollDatum.FieldName := 'Datum';
    xdsProtokollKundennummer.SetParentComponent(xdsProtokoll);
    xdsProtokollKundennummer.Name := 'xdsProtokollKundennummer';
    xdsProtokollKundennummer.FieldName := 'Kundennummer';
    xdsProtokollKundennummer.Size := 13;
    xdsProtokollNotiz.SetParentComponent(xdsProtokoll);
    xdsProtokollNotiz.Name := 'xdsProtokollNotiz';
    xdsProtokollNotiz.FieldName := 'Notiz';
    xdsProtokollNotiz.Size := 250;
    xdsProtokollPruefungErforderlich.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErforderlich.Name := 'xdsProtokollPruefungErforderlich';
    xdsProtokollPruefungErforderlich.FieldName := 'PruefungErforderlich';
    xdsProtokollPruefungErledigt.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErledigt.Name := 'xdsProtokollPruefungErledigt';
    xdsProtokollPruefungErledigt.FieldName := 'PruefungErledigt';
    xdsProtokollPruefungErledigtDurch.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErledigtDurch.Name := 'xdsProtokollPruefungErledigtDurch';
    xdsProtokollPruefungErledigtDurch.FieldName := 'PruefungErledigtDurch';
    xdsProtokollPruefungErledigtDurch.Size := 50;
    xdsProtokollBemerkung.SetParentComponent(xdsProtokoll);
    xdsProtokollBemerkung.Name := 'xdsProtokollBemerkung';
    xdsProtokollBemerkung.FieldName := 'Bemerkung';
    xdsProtokollBemerkung.Size := 255;
  finally
    TC.AfterLoadDFMValues;
    xdsKundendaten.AfterLoadDFMValues;
    xdsKundendatenKundennummer.AfterLoadDFMValues;
    xdsKundendatenEMail.AfterLoadDFMValues;
    xdsKundendatenKeinNewsletter.AfterLoadDFMValues;
    xdsProtokoll.AfterLoadDFMValues;
    xdsProtokollID.AfterLoadDFMValues;
    xdsProtokollDatum.AfterLoadDFMValues;
    xdsProtokollKundennummer.AfterLoadDFMValues;
    xdsProtokollNotiz.AfterLoadDFMValues;
    xdsProtokollPruefungErforderlich.AfterLoadDFMValues;
    xdsProtokollPruefungErledigt.AfterLoadDFMValues;
    xdsProtokollPruefungErledigtDurch.AfterLoadDFMValues;
    xdsProtokollBemerkung.AfterLoadDFMValues;
  end;
end;

end.
